<template>
  <div v-loading="loading">
    <!--汇总-->
    <Total v-if="!loading" style="min-height: 200px;"></Total>
    <Analysis v-if="!loading" style="min-height: 500px;"></Analysis>
    <!--交易统计-->
    <Transaction v-if="!loading"></Transaction>
  </div>
</template>

<script>
import StatisticsApi from "@/api/statistics.js";
import Total from "./part/Total.vue";
import Analysis from "./part/Analysis.vue";
import Transaction from "./part/Transaction.vue";
export default {
  components: {
    Total,
    Analysis,
    Transaction
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*数据对象*/
      dataModel: {}
    };
  },
  provide: function() {
    return {
      dataModel: this.dataModel
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      StatisticsApi.getUserTotal({}, true)
        .then(res => {
          Object.assign(self.dataModel, res.data);
          self.loading = false;
        })
        .catch(error => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/statistics/user/index.vue